export const genreItems = [
  { id: 'g-01', title: '雾港档案', type: '电视剧', tags: ['悬疑', '犯罪'], note: '刑侦单元剧，主线案件贯穿全季。' },
  { id: 'g-02', title: '长夜微光', type: '电视剧', tags: ['悬疑', '都市'], note: '都市悬疑，节奏克制张力足。' },
  { id: 'g-03', title: '江城旧事', type: '电视剧', tags: ['家庭', '年代'], note: '年代家庭群像，跨越三十年。' },
  { id: 'g-04', title: '归海', type: '电视剧', tags: ['古装', '历史'], note: '古装权谋，朝堂棋局层层递进。' },
  { id: 'g-05', title: '月落长安', type: '电视剧', tags: ['古装', '爱情'], note: '古装言情，服化道与群像出色。' },
  { id: 'g-06', title: '星河以北', type: '电视剧', tags: ['科幻', '悬疑'], note: '硬核设定的科幻悬疑长剧。' },
  { id: 'g-07', title: '逆风而行', type: '电视剧', tags: ['都市', '职场'], note: '职场与创业线并行的现实题材。' },
  { id: 'g-08', title: '春日回信', type: '电视剧', tags: ['爱情', '治愈'], note: '慢热治愈系爱情剧。' },
  { id: 'g-09', title: '海上列车', type: '电影', tags: ['冒险', '治愈'], note: '海上旅途题材的剧情冒险片。' },
  { id: 'g-10', title: '尘世微光', type: '电影', tags: ['家庭', '治愈'], note: '普通家庭的四季流转故事。' },
  { id: 'g-11', title: '暗涌', type: '电影', tags: ['犯罪', '悬疑'], note: '失踪案背后的犯罪悬疑片。' },
  { id: 'g-12', title: '星尘信笺', type: '电影', tags: ['科幻', '爱情'], note: '相隔光年的浪漫科幻片。' },
  { id: 'g-13', title: '第七码头', type: '电视剧', tags: ['历史', '悬疑'], note: '年代谍战，身份反转频繁。' },
  { id: 'g-14', title: '代码之城', type: '电视剧', tags: ['都市', '职场'], note: '聚焦程序员生态的都市剧。' },
  { id: 'g-15', title: '疾风骑士', type: '电影', tags: ['冒险', '职场'], note: '草根车队冲击职业赛场的体育片。' },
  { id: 'g-16', title: '山那边的信', type: '电视剧', tags: ['治愈', '家庭'], note: '返乡支教的日常流治愈剧。' },
];